export default "__VITE_ASSET__CIEQC8lw__"